import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { NovaGto } from '../../base/vo/nova-gto';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-planos-tratamento',
  templateUrl: './planos-tratamento.component.html',
  inputs: ['novaGto'],
  styleUrls: ['./planos-tratamento.component.css']
})
export class PlanosTratamentoComponent implements OnInit {

  @Input() novaGto: NovaGto;
  @Output() stepControl: EventEmitter<NovaGto> = new EventEmitter<NovaGto>();
  public filtros = false;
  public mostrarBotao = true;

  constructor() { }

  ngOnInit() {
  }
  
  nextStep() {
    var apto = this.buttonEnabled();
    if (apto) {
      let novaGto = new NovaGto();
      this.novaGto.codigoStep = 3;
      this.numerarProcedimentos();
      novaGto = this.novaGto;
      this.stepControl.emit(novaGto);
    }
  }

  buttonEnabled(){
    if(((this.novaGto.listaProcedimentos != null && this.novaGto.listaProcedimentos.length > 0 && !(this.novaGto.primeiraOrtodontia))
    || (this.novaGto.listaProcedimentos != null && this.novaGto.listaProcedimentos.length == 1 && this.novaGto.primeiraOrtodontia))
    && this.isValidAnexos()
    && this.isValidTipoExameRadiologico()){
      return true;
    }
    return false;
  }

  numerarProcedimentos(){
    this.novaGto.listaProcedimentos.forEach((item, index) => {
      let linha = index+1;
      let linhaTmp = item.linha;
      if(linha!=linhaTmp) {
      	this.ajustarImagensProcedimento(linhaTmp, linha);
      }
      item.linha = linha;
    });
  }
  
  ajustarImagensProcedimento(oldValue, newValue) {
    if(this.novaGto.anexos) {
  		this.novaGto.anexos.forEach((item, index) => {
  			if(item.linhaProcedimento == oldValue) {
  				item.linhaProcedimento = newValue;
  			}
  		});
    }
  }

  isValidAnexos():boolean {
  	//Checar anexos tratamento
	if(!this.isValidAnexosIncluidos(this.novaGto.anexos)) {
		return false;
	}
	
	return true;
  }
  
  isValidAnexosIncluidos(anexos):boolean {
	if(anexos && anexos.length>0) {
		for (let i = 0; i < anexos.length; i++) {
			if(anexos[i].isInvalidTipo || anexos[i].isInvalidSituacao) {
				return false;
			}
        }
	}
	return true;
  }
  
  isValidTipoExameRadiologico():boolean {
  	if(this.novaGto.tipoAtendimento.id != 2) {
  		return true;
  	}
  	
  	if(!isNullOrUndefined(this.novaGto.dentistaRadiologia)
  		&& !isNullOrUndefined(this.novaGto.dentistaRadiologia.nome)
  		&& !isNullOrUndefined(this.novaGto.dentistaRadiologia.cro)
  		&& !isNullOrUndefined(this.novaGto.dentistaRadiologia.uf)
  		) {
  		return true;
  	} else {
  		return false;
  	}
  }
}


// WEBPACK FOOTER //
// ./src/app/components/nova-gto/planos-tratamento/planos-tratamento.component.ts